import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { TEASER_BOXES_MEDIA_CONVERTER_TOKEN, TeaserBoxesMediaConverter } from './teaser-boxes-media.component.converter'
import { TEASER_BOX_VIDEO_CONVERTER_TOKEN, TeaserBoxVideoConverter } from './teaser-box-video/teaser-box-video.component.converter'
import { TEASER_BOX_IMAGE_CONVERTER_TOKEN, TeaserBoxImageConverter } from './teaser-box-image/teaser-box-image.component.converter'
import {
  TEASER_BOX_DOCUMENT_CONVERTER_TOKEN, TeaserBoxDocumentConverter
} from './teaser-box-document/teaser-box-document.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        teaserBoxesMediaFeature: {
          module: () => import('./teaser-boxes-media.module').then((m) => m.TeaserBoxesMediaModule),
          cmsComponents: ['teaserboxes_media'],
        },
      }
    }),
    {
      provide: TEASER_BOXES_MEDIA_CONVERTER_TOKEN,
      useClass: TeaserBoxesMediaConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        teaserboxes_media: TEASER_BOXES_MEDIA_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: TEASER_BOX_VIDEO_CONVERTER_TOKEN,
      useClass: TeaserBoxVideoConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        teaserbox_video: TEASER_BOX_VIDEO_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: TEASER_BOX_IMAGE_CONVERTER_TOKEN,
      useClass: TeaserBoxImageConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        teaserbox_image: TEASER_BOX_IMAGE_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: TEASER_BOX_DOCUMENT_CONVERTER_TOKEN,
      useClass: TeaserBoxDocumentConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        teaserbox_document: TEASER_BOX_DOCUMENT_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class TeaserBoxesMediaFeatureModule {}
